function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237",
  transform: "translate(-414.917 -156.761)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_235",
  "data-name": "Group 235",
  transform: "translate(-2.627 3.439)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M441.6,158.23a4.407,4.407,0,1,1-.753-2.465A4.4,4.4,0,0,1,441.6,158.23Z",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_307",
  "data-name": "Path 307",
  d: "M443.353,168.3c-.843-1.652-2.586-3.215-6.165-3.215a6.918,6.918,0,0,0-5.143,1.8",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.089
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_308",
  "data-name": "Path 308",
  d: "M444.11,172.109a7.715,7.715,0,0,0-.171-2.144",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.089
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_309",
  "data-name": "Path 309",
  d: "M428.814,173.266v1.569h-13.4V161.76h13.4v9.494",
  transform: "translate(0 3.156)",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  transform: "translate(418.814 163.226)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  y2: 3.178,
  transform: "translate(0)",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_42",
  "data-name": "Line 42",
  y2: 3.178,
  transform: "translate(6.603)",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_43",
  "data-name": "Line 43",
  x2: 13.397,
  transform: "translate(415.417 168.599)",
  fill: "none",
  stroke: "inherit",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgTidspunkt = function SvgTidspunkt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.133,
    height: 21.73,
    viewBox: "0 0 27.133 21.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTidspunkt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tidspunkt.fafdee92.svg";
export { ForwardRef as ReactComponent };